import styled, { css } from "styled-components";

export const FormGroup = styled.div`
  .input-group {
    &.pwd-field {
      .form-control {
        box-shadow: none;
      }
      .input-group-text {
        background: #e7e7e7;
        color: #495057;
        font-size: 22px;
      }
    }
  }
`;

export const FormLabelRadio = styled.div`
  ${({ theme }) => css`
    font-size: ${(props) => (props.small ? 17 : 20)}px;
    font-weight: 200;
    color: ${theme.colors.lightGrey};
    font-family: "Raleway", sans-serif;
    line-height: 32px;
    top: 25px;
    position: relative;
    right: 48%;
    @media only screen and (min-width: 900px) {
      font-size: 16px;
    }
  `}
`;

export const Fields = styled.input`
  ${({ theme, error }) => css`
    height: ${(props) => (props.small ? 15 : 32)}px;
    font-size: ${(props) => (props.small ? 15 : 20)}px;
    padding: 5px;
    width: 2%;
    border-radius: 2px;
    border: 1px solid #d9d9d9;
    position: relative;
    left: 41%;
    color: ${theme.colors.gstBlue};
    outline: 2px ${error ? `solid ${theme.colors.gstRed}` : ""};
    @media only screen and (min-width: 900px) {
      left: 48%;
    }
  `}
`;

export const Required = styled.span`
  ${({ theme }) => css`
    font-size: 1.2em;
    font-weight: 600;
    color: ${theme.colors.gstRed};
    position: relative;
  `}
`;
